angular.module('rjmNg.constants')
.constant('metricEnums',
  AGGREGATE_FUNCTIONS: Object.freeze
    COUNT: 'Count'
    COUNT_DISTINCT: 'Count Distinct'
    SUM: 'Sum'
    AVERAGE: 'Average'
    MAX: 'Maximum Value'
    MIN: 'Minimum Value'
    MEDIAN: 'Median'
    FIRST_QUARTILE: 'First Quartile'
    THIRD_QUARTILE: 'Third Quartile'
    TENTH_PERCENTILE: 'Tenth Percentile'
    NINETIETH_PERCENTILE: 'Ninetieth Percentile'
    SUB_COUNT: 'Count Across Active Subscriptions'
    SUB_COUNT_DISTINCT: 'Count Distinct Across Active Subscriptions'
    SUB_SUM: 'Sum Across Active Subscriptions'
    SUB_AVERAGE: 'Average Across Active Subscriptions'

  DIMENSION_EDITOR_ACTIONS: Object.freeze
    ADD: 'Add'
    REMOVE: 'Remove'

  AGGREGATE_FUNCTIONS_IDS: Object.freeze
    COUNT: 1
    COUNT_DISTINCT: 6
    SUM: 2
    AVERAGE: 3
    MAX: 4
    MIN: 5
    SUB_COUNT: 11
    SUB_COUNT_DISTINCT: 12
    SUB_SUM: 13
    SUB_AVERAGE: 14
    MEDIAN: 33
    FIRST_QUARTILE: 34
    THIRD_QUARTILE: 35
    TENTH_PERCENTILE: 36
    NINETIETH_PERCENTILE: 37
    EXISTS: 45

)
